<template>
  <div class="ss__user__prime__card__perspective__wrapper">
    <div class="ss__user__prime__card__perspective">
    <div
      :class="[
        'ss__user__prime__card__wrapper',
        {'ss__user__prime__card__wrapper--flipped': flipped}
      ]"
      @click="toggle">
      <div
        ref="card"
        class="ss__user__prime__card ss__user__prime__card--front">
        <SsPrimeLogo class="comp__PrimeLogo"/>
        <div class="ss__user__prime__card__avatar__wrapper">
          <SsPortrait
            v-if="userInfo"
            class="ss__user__prime__card__avatar"
            :data="userInfo" :size="120"
            :proportion="1"
            :showBadge="true"
          />
        </div>
        <div
          ref="qrCodeRef"
          class="ss__user__prime__card__qrcode"
        />
        <div v-if="userInfo && userInfo.member" class="ss__user__prime__card__footer">
          <div class="ss__user__prime__card__row__wrapper">
            <div class="ss__user__prime__card__info__item user__info__item">
              <span class="ss__user__prime__card__info__item__label">少数派会员</span>
              <div class="ss__user__prime__card__info__item__value">{{ userInfo.nickname }}</div>
            </div>
            <div class="ss__user__prime__card__info__item valid__date__item">
              <span class="ss__user__prime__card__info__item__label">有效期</span>
              <span
                v-show="userInfo.member.end_time"
                class="ss__user__prime__card__info__item__value">
                {{ userInfo.member.end_time * 1000 | formatDate('YYYY/MM/DD') }}
              </span>
            </div>
          </div>
          <div class="ss__user__prime__card__row__wrapper">
            <div v-if="userInfo && userInfo.member">
              <span
                v-show="userInfo.member.is_pay"
                class="prime__code">
                No.{{ userInfo.member.member_code }}
              </span>
            </div>
            <div v-if="userInfo.created_at" class="join__date">{{ userInfo.created_at * 1000 | formatDate('YYYY 年 MM 月') }}成为少数派</div>
          </div>
        </div>

        <div class="ss__user__prime__card__image">
          <img v-if="blob" :src="blob" alt=""/>
        </div>
      </div>
      <div class="ss__user__prime__card ss__user__prime__card--back">
        <SsPrimeLogo class="comp__PrimeLogo"/>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import QRCode from 'arale-qrcode'
import domtoimage from 'dom-to-image'
import SsPortrait from '../SsPortrait'
import SsPrimeLogo from '../SsPrimeLogo'

export default {
  name: 'SsUserPrimeCard',

  components: {
    SsPortrait,
    SsPrimeLogo
  },

  inject: ['$getUserInfo'],

  data () {
    return {
      flipped: false,
      blob: null
    }
  },

  computed: {
    userInfo () {
      const userInfo = this.$getUserInfo()
      if (!userInfo) {
        return {
          nickname: '吃派的水獭',
          member: {}
        }
      }
      return userInfo
    }
  },

  watch: {
    userInfo: {
      immediate: true,
      handler () {
        if (this.userInfo?.slug) {
          this.$nextTick(() => {
            this.generateQrCode()
            this.draw()
          })
        }
      }
    }
  },

  methods: {
    toggle () {
      this.flipped = !this.flipped
    },
    generateQrCode () {
      const target = this.$refs.qrCodeRef
      if (!target || !this.userInfo?.slug) return
      target.innerHTML = ''
      const qrCode = new QRCode({
        text: `${window.location.origin}/u/${this.userInfo.slug}`,
        size: 152,
        background: 'transparent',
        foreground: '#000',
        correctLevel: 1
      })
      const img = document.createElement('img')
      img.src = qrCode.toDataURL()
      target.innerHTML = ''
      target.appendChild(img)
    },
    async draw () {
      const node = this.$refs.card?.cloneNode(true)
      if (!node) return
      try {
        const scale = 2
        const cardWidth = 423
        node.style.position = 'fixed'
        node.style.left = '0'
        node.style.top = '0'
        node.style.opacity = '0'
        node.style.width = `${cardWidth}px`
        node.style.borderRadius = '0px'
        document.body.appendChild(node)
        const cardHeight = node.offsetHeight
        this.blob = await domtoimage.toJpeg(node, {
          quality: 1,
          width: cardWidth * scale,
          height: cardHeight * scale,
          style: {
            opacity: 1,
            width: `${cardWidth}px`,
            height: `${cardHeight}px`,
            boxShadow: 'none',
            zoom: 1,
            transform: `scale(${scale})`,
            transformOrigin: 'top left'
          }
        })
        // 修复图片不渲染的问题，原因未知，暂时先这样处理
        this.blob = await domtoimage.toJpeg(node, {
          quality: 1,
          width: cardWidth * scale,
          height: cardHeight * scale,
          style: {
            opacity: 1,
            width: `${cardWidth}px`,
            height: `${cardHeight}px`,
            boxShadow: 'none',
            zoom: 1,
            transform: `scale(${scale})`,
            transformOrigin: 'top left'
          }
        })
      } finally {
        node.remove()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl';
.ss__user__prime__card__perspective {
  perspective: 800px;
  cursor: pointer;
}

.ss__user__prime__card__wrapper {
  width: 423px;
  height: 593px;
  position: relative;
  transform-style: preserve-3d;
  transition transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border-radius: var(--radius-PrimeCard, 16px);
  box-shadow: 0 32px 62px 0px rgba(0, 0, 0, 0.12);

  &::before {
    content: '';
    display: block;
    padding-top: 593px;
  }

  &.ss__user__prime__card__wrapper--flipped {
    transform rotateY(-180deg)
  }
}

.ss__user__prime__card {
  width: 423px;
  height: 593px;
  border-radius: var(--radius-PrimeCard, 16px);
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  background: url('./_images/prime__card__back__bg.png') no-repeat;
  background-size: cover;
  backface-visibility: hidden;

  .ss__user__prime__card__avatar__wrapper {
    width: 120px;
    position: relative;
    margin: auto;
    margin-bottom: 62px;
    margin-top: 115px;
    .ss__user__prime__card__avatar {
      --size: 120px!important;
      --proportion: 1!important;
    }
  }

  .ss__user__prime__card__qrcode {
    position: relative;
    width: 184px;
    height: 184px;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 16px;
    background: #fff;
    margin: auto;
    z-index: 2;
    >>> img {
      width 100%;
    }
  }

  .ss__user__prime__card__footer {
    height: 142px;
    box-sizing: border-box;
    background: #373DF5;
    padding: 24px;
    color: rgba(#fff, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: -30px;
  }

  .ss__user__prime__card__row__wrapper {
    display: flex;
    justify-content: space-between;
  }

  .ss__user__prime__card__info__item {
    display: flex;
    flex-direction: column;
  }

  .ss__user__prime__card__info__item__label {
    font-size: 12px;
    font-weight: 600;
    color: rgba(#fff, 0.4);
  }

  .valid__date__item {
    text-align: right;
  }

  .user__info__item {
    text-align: left;
  }

  .ss__user__prime__card__info__item__value {
    font-size: 16px;
    font-weight: 600px;
  }

  .prime__code,
  .join__date {
    font-size: 13px;
    font-weight: 600;
    color: #fff;
  }
}

.ss__user__prime__card--front {
  --color-PrimeLogo: #fff;
  .comp__PrimeLogo {
    width: 105px;
    height: 48px;
    position: absolute;
    top: 16px;
    left: 20px;
  }
  .ss__user__prime__card__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.ss__user__prime__card--back {
  background: url('./_images/prime__card__back__bg.png') no-repeat;
  background-size: cover;
  transform: rotateY(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  .comp__PrimeLogo {
    display: block;
    width: 175px;
    height: 80px;
  }
}
</style>
